/*
 * Copyright (C) Motorola Solutions, INC.
 * All Rights Reserved.
 */

import { Report1 } from './report-1';

export class InputReport1 extends Report1 {
}
